<template>
  <div>
    <v-dialog v-model="show" v-if="show" width="800" persistent>
      <v-card>
        <v-card-title class="justify-space-between">
          <template v-if="tab == 0">Upload Image</template>
          <template v-else>Edit Image</template>
          <!-- <v-btn v-else fab text small @click="handleBack"><v-icon class="text-right">mdi-chevron-left</v-icon></v-btn> -->

          <v-btn fab text small @click="handleClose"><v-icon class="text-right text--secondary">close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <vue-dropzone
                ref="dropzone"
                id="Dropzone"
                :options="dropzoneOptions"
                @vdropzone-file-added="fileAdded"
                :useCustomSlot="true"
              >
                <p class="mt-n-10 text-body-1 primary--text">
                  Drag and drop or
                  <span class="text-decoration-underline">Browse files</span>
                </p>
              </vue-dropzone>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <!-- <v-card-title>
                  Edit Image
                </v-card-title> -->
                <v-card-text>
                  <ImageCropper
                    :selectedImage="selectedImage"
                    @uploaded="handleUploaded"
                    :previewType="previewType"
                    :key="refreshCropper"
                    :link="link"
                    :businessCardRotatorObject="businessCardRotatorObject"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ImageCropper from "@/components/ImageCropper";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    fab: { type: Boolean, default: false },
    previewType: { type: String, default: "reverseImageURL" },
    show: { type: Boolean, default: false },
    link: { type: Object },
    businessCardRotatorObject: { type: Object },
    image: { type: String, default: "" },
  },
  components: {
    vueDropzone: vue2Dropzone,
    ImageCropper,
  },
  data() {
    return {
      dropzoneOptions: {
        autoProcessQueue: false,
        url: "http://localhost",
        previewsContainer: false,
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
      },
      tab: 0,
      selectedImage: "",
      refreshCropper: 0,
    };
  },

  computed: {
    ...mapGetters(["linkInBio", "businessProfile"]),
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails"]),
    fileAdded(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        //event.target.result - is dataURL datas
        this.selectedImage = event.target.result;
        this.tab = 1;
        this.refreshCropper = this.refreshCropper == 0 ? 1 : 0;
      };
    },

    handleUploaded(downloadURL) {
      //Save uploaded image to business profile
      if (this.previewType != "thumbnail") {
        this.businessProfile.imageURLs?.unshift(downloadURL);
        this.updateBusinessProfileDetails(this.businessProfile);
      }

      this.refreshCropper = this.refreshCropper == 0 ? 1 : 0;
      this.tab = 0;
      this.$emit("uploaded", downloadURL);
    },

    handleClose() {
      this.tab = 0;
      this.refreshCropper = this.refreshCropper == 0 ? 1 : 0;
      this.$emit("close");
    },

    handleBack() {
      this.tab = 0;
      this.refreshCropper = this.refreshCropper == 0 ? 1 : 0;
    },
  },
};
</script>

<style scoped>
.fab {
  border-radius: 50%;
}

.cursor-pointer {
  cursor: pointer !important;
}
</style>
